import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import LanguageDetector from 'i18next-browser-languagedetector';


i18n
  .use(resourcesToBackend((language, namespace, callback) => {
    import(`./assets/i18n/locales/${namespace}/${language}.json`)
      .then((resources) => {
        callback(null, resources)
      })
      .catch((error : any) => {
        callback(error, null)
      })
  }))
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    react: {
      useSuspense: false,
    },
    ns: [
      "translation"
    ],
    keySeparator: "__",
    nsSeparator: "::",
    fallbackLng: 'en',
    defaultNS: "commons",
    debug: false,
    interpolation: {
      escapeValue: false
    }
  });


export default i18n;
